import React from 'react';
import { FaExclamationCircle } from 'react-icons/fa';

/**
 * Inline validation message shown directly under the field it belongs to. Renders
 * nothing when there is no message. `role="alert"` makes screen readers announce it
 * as soon as it appears; the input points at it through `aria-describedby`.
 */
const FieldError = ({ id, children }) => {
  if (!children) return null;
  return (
    <div id={id} className="field-error" role="alert">
      <FaExclamationCircle className="field-error-icon" aria-hidden="true" />
      <span>{children}</span>
    </div>
  );
};

export default FieldError;
